// AUTO-GENERATED by /builds/seeds/patentstyret/xp/node_modules/@enonic/react4xp/dist/globals/generateTempES6SourceAndGetFilename.js

import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

(function() {
	globalThis.React = React;
	globalThis.ReactDOM = ReactDOM;
	globalThis.ReactDOMServer = ReactDOMServer;
} )();
